import { UseQueryResult, useQuery } from 'react-query';
import { api } from '../api';

async function getConsentUrl(): Promise<{ url: string }> {
    const { data } = await api.get(`/xero/consent-url`);
    return data;
}

export function useXeroConsentUrl(): UseQueryResult<{ url: string }, unknown> {
    return useQuery(['xero-consent-url'], () => getConsentUrl(), { enabled: false, refetchOnWindowFocus: false });
}
